/* istanbul ignore file */
import { keys } from '@mfs/client/common/constants/keyBoardKeys'
import { Tooltip } from '@pcln/horizon'
import { Box, Heading, IconButton, Text } from 'pcln-design-system'
import { Close, InformationOutline } from 'pcln-icons'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export function RecommendedListingsHeader({ cityName }) {
  const activeTabId = useSelector((state) => state?.activeTabId)
  const [recFlightsTooltipOpen, setRecFlightsTooltipOpen] = useState(false)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  let headerText = `Recommended Flights to ${cityName}`
  if (activeTabId === 2) {
    headerText = 'Recommended Return Flights'
  }

  return (
    <Box px={[2, null, null, null, 0]}>
      <Heading fontWeight='bold' fontSize={['16px', '16px', '16px', '16px', '20px']}>
        {headerText}
      </Heading>

      <div className='flex flex-row gap-1 items-center mt-1 mb-4'>
        <Text color='text.light' fontSize={0}>
          Based on price and convenience
        </Text>
        {isMounted && (
          <Tooltip
            delay={0}
            emphasis
            open={recFlightsTooltipOpen}
            triggerNode={
              <IconButton
                icon={<InformationOutline color='primary' size={16} />}
                onClick={() => setRecFlightsTooltipOpen(!recFlightsTooltipOpen)}
                onMouseLeave={() => setRecFlightsTooltipOpen(false)}
                onMouseEnter={() => setRecFlightsTooltipOpen(true)}
                onFocus={() => setRecFlightsTooltipOpen(true)}
                onBlur={() => setRecFlightsTooltipOpen(false)}
                onKeyDown={(e) => {
                  if (e.key === keys.enter || e.key === keys.space || e.type === 'click') {
                    e.preventDefault()
                    setRecFlightsTooltipOpen(!recFlightsTooltipOpen)
                  }
                }}
              />
            }
          >
            <div className='flex items-center w-[296px] lg:w-[268px]'>
              <div>
                Recommended flights are ranked by price and convenience factors (duration, stops, and
                layovers).
              </div>

              <div className='lg:hidden ml-1.5'>
                <IconButton icon={<Close size={20} />} onClick={() => setRecFlightsTooltipOpen(false)} />
              </div>
            </div>
          </Tooltip>
        )}
      </div>
    </Box>
  )
}
